/**
 * 创建远程搜索、远程下拉
 * @param value
 * @param conf
 */
export function createRemoteModel (value, conf) {
  let model = {}
  try {
    model.remoteMethod = conf.remoteMethod
    model.labelKey = conf.$attr.labelKey
    model.valueKey = conf.$attr.valueKey
    model.options = value
    if (conf.$attr.multiple) {
      model.allSearchResult = value.reduce((prev, cur) => {
        prev[cur.value] = cur
        return prev
      }, {})
      model.queryValue2 = value.map(v => v.value)
    } else {
      model.queryValue = value[0].value
    }
  } catch (e) {
    model.queryValue2 = []
    model.queryValue = ''
  }
  return model
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/custom-filter/create-rules.js